import { createCart } from '../actions/cartActions';
import { SCAN, STORE_LIST } from '../constants/routes';
import { notifyInfo } from './Notify';
export const deployScan = async ({store, user, entryQr, dispatch, axiosInstance, navigate, cartItems}) => {
    if (
      cartItems?.isPaid ||
      (!cartItems?._id && store?.id) ||
      (!localStorage.getItem('cartItems') && store?.id)
    ) {
      const orderCreate = {
        storeId: store?.id,
        clientId: user?._id || '',
        entryQr: entryQr,
      };

      try {
        dispatch(
          createCart(orderCreate, axiosInstance, () =>
            navigate(SCAN, { state: { entryQr: entryQr || '' } }),
          ),
        );
      } catch (e) {
        console.error('Error createCart', e);
      }
    } else if (cartItems?._id && localStorage.getItem('cartItems')) {
      navigate(SCAN);
    } else {
      notifyInfo('Il faut d\'abord choisir un magasin 😉');
      navigate(STORE_LIST, { state: { entryQr: entryQr || '' } });
    }
  };